import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import { purgeLegacyAuthSession } from "./core/utils/purgeLegacyAuthSession.ts";
import { reloadOnMissingChunk } from "./core/utils/reloadOnMissingChunk.ts";
import { useSentry } from "./features/sentry/utils/useSentry.ts";
import "./core/styles/preflight.css";

useSentry();
purgeLegacyAuthSession();
reloadOnMissingChunk();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
